if (!customElements.get('featured-products-slider')) {
  class FeaturedProductsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 1,
        spaceBetween: 100,
        breakpoints: {
          750: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('featured-products-slider', FeaturedProductsSlider);
}
